import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import watermark1 from '../assets/watermark1.png';
import watermark2 from '../assets/watermark2.png';
import watermark3 from '../assets/watermark3.png';

const Watermark = ({ id }) => {
    const getWatermark = id => {
        switch (id) {
            case 1:
                return (
                    <div className={styles.watermark}>
                        <img src={watermark1} alt="" />
                    </div>
                );
            case 2:
                return (
                    <div className={styles.watermark}>
                        <img src={watermark2} alt="" />
                    </div>
                );
            case 3:
                return (
                    <div className={styles.watermark}>
                        <img src={watermark3} alt="" />
                    </div>
                );
            default:
                return null;
        }
    };

    return <>{getWatermark(id)}</>;
};

Watermark.propTypes = {
    id: PropTypes.number,
};

export default errorBoundary(Watermark);
